import SVG from "react-inlinesvg";
import styled from "styled-components";
import HoverTippable from "src/components/StoryBible/HoverTippable";
import StickyNoteAnchor from "../../../StickyTour/StickyNoteAnchor";
import { AnchorIds, TourSignal } from "../../../StickyTour/TourTypes";
import { useStickyTourStore } from "../../../../stores/stickyTourStore";

const PlanDraftButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  height: 42px;
  padding: 0 14px 0 12px;
  border-radius: 10px;
  cursor: pointer;
  background-color: var(--primary-cta);
  border: none;
  color: var(--cta-text-color);
  white-space: nowrap;
  font-family: "Inter";
  font-weight: 500;

  &:hover {
    opacity: 0.9;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  .sparkle {
    width: 24px;
    height: 24px;
    path {
      fill: var(--cta-text-color);
    }
  }

  .labels {
    display: flex;
    flex-direction: column;
    padding: 9px 8px 9px 6px;

    .label {
      font-size: 14.8px;
      line-height: 1.3;
    }

    .sublabel {
      font-size: 9.5px;
      margin-bottom: 2px;
    }
  }
`;

function RunPreflightSelectModelButton({ requesting, outOfQuota, prosePreflight }) {
  const sendFlowSignal = useStickyTourStore((state) => state.sendFlowSignal);

  return (
    <HoverTippable
      generateDisabled={requesting}
      generateDisabledMessage={"A generation is already in progress"}
      submenuActive={true}
      id="button-container-plan-draft"
    >
      <StickyNoteAnchor anchorId={AnchorIds.DRAFT_PROSE_GENERATE} />
      <PlanDraftButton
        id="button-plan-draft"
        className={requesting || outOfQuota ? "disabled" : ""}
        role="button"
        tabIndex={0}
        onClick={() => {
          if (requesting || outOfQuota) return;
          sendFlowSignal(TourSignal.DRAFT_PROSE_GENERATE_CLICKED);
          prosePreflight();
        }}
      >
        <SVG src="/assets/AI-sparkle.svg" className="sparkle" />
        <div className="labels">
          <span className="label">Plan Draft</span>
          <span className="sublabel">All Scenes</span>
        </div>
      </PlanDraftButton>
    </HoverTippable>
  );
}

export default RunPreflightSelectModelButton;
